import { FileSelectField, FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface Props {
  formMode: FormMode;
  onFileChange?: (file: File | null) => void;
}

export const OtherTab = ({ formMode, onFileChange }: Props) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='space-y-1'>
        <div className='flex items-center'>
          <div className='flex items-center'>
            <Label className='w-40 min-w-40 text-left'>Ngày sinh</Label>
            <FormField name='birth_date' type='date' disabled={formMode === 'view'} className='w-44' />
          </div>

          <div className='ml-4 flex items-center'>
            <Label className='w-40 min-w-40 text-left'>Số CMND/CCDC</Label>
            <FormField name='id_number' type='text' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <div className='flex items-center'>
            <Label className='w-40 min-w-40 text-left'>Người đại diện p.luật</Label>
            <FormField name='legal_representative' type='text' disabled={formMode === 'view'} />
          </div>

          <div className='ml-12 flex items-center'>
            <Label className='w-40 min-w-40 text-left'>Chức vụ</Label>
            <FormField name='representative_position' type='text' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Số tài khoản</Label>
          <FormField name='bank_account' type='text' disabled={formMode === 'view'} />
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Tên ngân hàng</Label>
          <div className='w-full'>
            <FormField name='bank_name' type='text' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Chi nhánh</Label>
          <div className='w-full'>
            <FormField name='bank_branch' type='text' disabled={formMode === 'view'} />
          </div>
        </div>
      </div>
    </div>
  );
};
